import React from "react";
import Footer from "../Component/Footer";
import Header from "../Component/Header";

export default function Club() {
  return (
    <div>
      <Header />

      {/* <div className="divider site-logo">
        <div className="header-text" style={{ float: "left" }}>
          <span>CLUB</span>
        </div>
      </div> */}

      <div className="container header-start ">
        <b>
          <h1
            className=" container main-text text-center"
            style={{ color: "#911146", fontSize: "36px" }}
          >
           THE COMMUNITY CLUB
          </h1>
        </b>
        <p className="sub-text" style={{ color: "black", fontSize: "24px" }}>
          We're investing in community tools, platforms, and other companies
          that are making an impact on how we gather, connect, and engage.
        </p>
      </div>
      <Footer/>
    </div>
  );
}
